import { useDispatch as useDispatchRaw, useSelector as useSelectorRaw } from "react-redux";
import { wrapFunction } from "utils/collect";
export function useSelector(selector, equalityFn) {
    return useSelectorRaw(selector, equalityFn);
}
export function useDispatch() {
    return useDispatchRaw();
}
export function wrapDispatch(dispatch, actionCreator) {
    return wrapFunction(dispatch, actionCreator);
}
